module.exports = __webpack_public_path__ + "img/AlloverRed.c8f48424.jpg";